/**
 *  OCS Meteogram - 2.0.3
 *  This module initializes and creates the meteogram. This is a collection of charts working together
 *
 *	Requires Moolite 1.3.1
 *	Requires OCS.Graphs 2.2.0
 *	Requires Jquery
 */

var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Meteogram = OCS.Meteogram || {};
OCS.Functions.define_meteogram_class = function () {
    OCS.Classes.OCSMeteogram = new Class({
        Extends: OCS.Classes.OCSGraph,
        Implements: [OCS.Classes.MeteogramExport, new Class(OCS.Interfaces.UniqueId)],
        class_name: "OCSMeteogram",
        debug: false,
        gNewDataFunctionRunning: false,
        charts: {},
        chart: null,
        options: {
            std_meteogram: false,
            legend_in_all_charts: false, // Show the legend in all the attached charts
            refresh_rate: 1.5 * 60 * 1000,
            chart_ops: {
                global_chart_ops: {
                    dynamic_tooltip: false,
                    chart: {

                    },
                    chart_tooltip: {
                        enabled: true,
                    },
                    x_axis_ops: {
                        events: {
                        }
                    }
                }
            },
            form_handler: function (settings) {
                if (this.debug) {
                    console.log("No form_handler function was set");
                }
            },
            url_meteogram_base: "/index.php/weather/meteogram/",
            x_axis_ops: {
                tickPosition: 'outside',
                offset: 1,
                labels: {
                    style: {
                        color: '#545454',
                        fontSize: '9px'
                    }
                }
            },
        },
        initialize: function (options) {
            this.debug_console("START INIT!");


            this.setOptions(options);
            this.initialize_events();
            this.options.chart_ops.global_chart_ops.x_axis_ops.events.setExtremes = this.set_extremes.bind(this);
            if (this.options.chart_ops) {
                this._process_chart_options();
            }
            this.init_export_buttons();
            this.init_duration();
            this.debug_console("stid:" + this.options.stid);
        },

        _init_handlers: function () {
            jQuery('#stid, #duration').change(function (e) {
                document.location.href = this.options.url_meteogram_base + jQuery('#stid').val() + "/" + jQuery('#duration').val();
            });
        },
        on_request_success: function (jsonData) {
            if (jsonData.error) {
                return false;
            }
            if (jsonData && jsonData.json && jsonData.json.data) {
                this.set_data(jsonData.json.data);

                Object.each(this.charts, function (chart) {
                    var data_requested = chart.get_data_names();
                    var data_recieved = {};
                    data_requested.each(function (field) {
                        if (this.data[field]) {
                            data_recieved[field] = this.data[field];
                        }
                    }, this);
                    chart.set_data([data_recieved]);
                    chart.fireEvent('new_data_processed', chart, 1);
                }, this);
                this.fireEvent('new_data_processed', this, 1);
            }
        },
        _process_chart_options: function () {
            var graph_settings;
            var graph_ops;
            if (this.options.chart_ops && this.options.chart_ops.charts && Object.keys(this.options.chart_ops.charts).length) {
                Object.each(this.options.chart_ops.charts, function (ops, key) {
                    // Build the options for the chart
                    graph_ops = OCS.Utilities.combine_objects(this.options.chart_ops.global_chart_ops, ops);

                    var render = jQuery('<div class="chart">');
                    render.appendTo('#' + this.options.chart.renderTo);
                    graph_ops.chart.renderTo = render[0];

                    this.charts[key] = new OCS.Classes.OCSGraph(graph_ops);
                    this.charts[key].id = this.create_unique_id();
                }, this);
            }
        },
        draw_graph: function () {
            if (this.charts) {
                Object.each(this.charts, function (chart, i) {
                    chart.draw_graph();
                }, this);
            }
        },
        refresh_data: function () {
            if (this.charts) {
                this.parent();
            }
        },
        is_chart_tooltip_enabled: function () {
            return this.options.chart_ops.global_chart_ops.chart_tooltip.enable;
        },
        get_var_settings: function () {
            if (this.options.std_meteogram) {
                return 'meteogram/1';
            } else {
                var req_vars = [];
                var req_units = [];
                if (Object.keys(this.charts).length) {
                    Object.each(this.charts, function (chart, i) {
                        chart.options.series.each(function (series) {
                            if (series.data_var) {
                                req_vars.push(series.data_var);
                                if (series.data_units) {
                                    req_units.push(series.data_units);
                                } else {
                                    req_units.push("");
                                }
                            }
                        });
                    });

                }
                var var_settings;
                if (req_vars.length) {
                    var_settings = 'var/' + req_vars.join();
                    if (req_units.length) {
                        var_settings += '/units/' + req_units.join();
                    }
                }
                return var_settings;
            }
        },
        // Sync the extremes of all the attached graphs.
        set_extremes: function (e) {
            if (this.charts && e.trigger !== 'syncExtremes') { // Prevent feedback loop
                Object.each(this.charts, function (chart, i) {
                    chart.set_extremes(e);
                });
            }
        },
        get_chart_for_event: function (e) {
            var charts, i;
            charts = Object.values(this.charts);
            for (i = 0; i < charts.length; i++) {
                if (charts[i].get_chart_container() === e.currentTarget) {
                    return charts[i];
                }
            }
        },
        // events
        on_container_mouse_move_event: function (e) {
            var chart, point, ref_chart, ref_point, plot_dist, series,
                    i, j, event, ref_chart_id;
            var points = [];

            ref_chart = this.get_chart_for_event(e);
            if (ref_chart) {
                ref_chart_id = ref_chart.id;
                ref_point = ref_chart.get_reference_point(e);
                if (ref_point) {
                    Object.each(this.charts, function (chart_obj, i) {
                        chart = chart_obj.get_chart();
                        for (j = 0; j < chart.series.length; j++) {
                            series = chart.series[j];
                            if (series.visible) {
                                point = series.data[ref_point.index];
                                if (point && point.y !== undefined && point.y !== null) {
                                    points.push(point);
                                    if (this.options.chart_ops.global_chart_ops.dynamic_tooltip) {
                                        if (chart_obj.id === ref_chart_id) {
                                            chart_obj.enable_chart_tooltip();
                                        } else {
                                            chart_obj.disable_chart_tooltip();
                                        }
                                    }
                                    point.highlight(e);
                                }
                            }
                        }

                    }.bind(this));
                }
            }



            chart = ref_chart.get_chart();
            if (chart) {
                Highcharts.hoverChartIndex = chart.index;
                e = chart.pointer.normalize(e);
                e.returnValue = false; // #2251, #3224

                if (chart.mouseIsDown === 'mousedown') {
                    chart.pointer.drag(e);
                }

                // Show the tooltip and run mouse over events (#977)
                if ((chart.pointer.inClass(e.target, 'highcharts-tracker') ||
                        chart.isInsidePlot(e.chartX - chart.plotLeft, e.chartY - chart.plotTop)) && !chart.openMenu) {
                    chart.pointer.runPointActions(e);
                    if (points.length) {
                        chart.tooltip.refresh(points);
                    }
                }
            }
        }
    });
};
OCS.Functions.define_meteogram_class();
